module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.fullCalendar) ? _c('div', {
    staticClass: "navigator"
  }, [_c('div', {
    staticClass: "date-scroller d-flex align-items-center",
    on: {
      "click": _vm.backToList
    }
  }, [_c('arrow', {
    class: ['mr-1', {
      'loading-events': _vm.getIsLoadingEvents
    }],
    attrs: {
      "direction": "left",
      "amount": "-1",
      "disabled": _vm.getIsLoadingEvents
    },
    on: {
      "updateArrowDate": _vm.updateArrowDate
    }
  }), _vm._v(" "), _c('arrow', {
    class: {
      'loading-events': _vm.getIsLoadingEvents
    },
    attrs: {
      "direction": "right",
      "amount": "1",
      "disabled": _vm.getIsLoadingEvents
    },
    on: {
      "updateArrowDate": _vm.updateArrowDate
    }
  }), _vm._v(" "), _c('span', [_c('vue-datepicker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getCurrentView == 'agendaDay'),
      expression: "getCurrentView == 'agendaDay'"
    }],
    ref: "datepicker",
    staticClass: "vdp-datepicker dateRangePicker datepicker-align-left",
    attrs: {
      "value": _vm.getExpandedDay
    },
    on: {
      "input": _vm.setExpandedDay
    }
  })], 1), _vm._v(" "), (_vm.getCurrentView != 'agendaDay') ? _c('span', {
    staticClass: "fs-largest text-center px-2"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.fullCalendar.view.title) + "\n\t\t")]) : _vm._e(), _vm._v(" "), (_vm.getIsLoadingEvents) ? _c('div', {
    staticClass: "loader ml-3"
  }, [_vm._v("Loading...")]) : _vm._e()], 1), _vm._v(" "), (_vm.fullCalendar) ? _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('div', {
    staticClass: "btn-group d-flex"
  }, [_vm._l((_vm.periods), function(period) {
    return _c('button', {
      key: period.id,
      staticClass: "btn",
      class: {
        'bg-dark lightest': period.value == _vm.fullCalendar.view.name &&
          !(period.value == 'agendaDay' && _vm.highlightTodayButton),
        'bg-faded dark': period.value != _vm.fullCalendar.view.name ||
          (period.value == 'agendaDay' && _vm.highlightTodayButton),
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.changeView(period)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(period.label) + "\n\t\t\t")])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    class: {
      'bg-dark lightest': _vm.highlightTodayButton,
      'bg-faded dark': !_vm.highlightTodayButton,
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goToToday
    }
  }, [_vm._v("\n\t\t\t\tToday\n\t\t\t")])], 2)]) : _vm._e(), _vm._v(" "), (_vm.accessPermissionFilter(['admin', 'supervisor'])) ? _c('div', {}, [_c('button', {
    staticClass: "btn ml-4 bg-dark",
    on: {
      "click": _vm.openCreateEvent
    }
  }, [_c('i', {
    staticClass: "ico ico-add mt-1"
  }), _vm._v("New event\n\t\t")])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-2fdeed88", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fdeed88"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/Navigator.vue
// module id = 2626
// module chunks = 0